import * as angular from 'angular';
import {IController} from "angular";
import {ServicesViewsStateType} from "../../types/services-views-state.type";
import {SettingsService} from "../../../site-preferences/services/settings-service.service";
import {CustomFieldModel} from "../../../site-preferences/models/custom-field.model";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class DeliveriesFiltersPanelCtrl implements IController {
  settings: any;
  enableColumnsSection?: boolean;
  onSettingsChange: Function;

  public packageCustomFields: CustomFieldModel[] = [];

  /* @ngInject */
  constructor(private $mdPanel, private settingsService: SettingsService) {
  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          daysBefore: this.settings.daysBefore,
          daysAfter: this.settings.daysAfter,
          actionType: this.settings.actionType,
          totalsTimeInterval: this.settings.totalsTimeInterval,
          defaultGroup: this.settings.defaultGroup,
          sortTimeWindow: this.settings.sortTimeWindow,
          columns: angular.copy(this.settings.columns),
          mapColumns: angular.copy(this.settings.mapColumns),
          enableColumnsSection: angular.copy(this.enableColumnsSection),
          dynamicColumns: angular.copy(this.settings.dynamicColumns),
          packageDynamicColumns: angular.copy(this.settings.packageDynamicColumns),
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DeliveriesSettingsCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: require('./template/panel-template.html').default,
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason) => {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig, parentScope) {
    parentScope.onSettingsChange({
      settings: settingsConfig
    })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesSettingsPanel', {
    bindings: {
      settings: '<',
      enableColumnsSection: '<?',
      onSettingsChange: '&',
    },
    template: require('./deliveries-settings-panel.html').default,
    controller: DeliveriesFiltersPanelCtrl
  });

class DeliveriesSettingsCtrl implements IController {

  public enabledSections: any;
  private columnsPermissions: any;
  private settingsConfig: any;
  public enableColumnsSection?: boolean;

  public pageName: string;
  public columnsVisibilityMap: any;
  public mapColumnsVisibilityMap: any;

  constructor(private mdPanelRef, private deliveriesConstants, private $state, private commonsConstants,
              private splitService: SplitService, private $timeout) {
  }

  $onInit() {
    this.pageName = this.$state.current.name;

    this.enabledSections = {
      columns: false,
      mapColumns: false,
      dynamicTableColumns: false,
      packageDynamicColumns: false,
      viewSettings: false,
      totalsTimeInterval: false,
    }

    this.columnsPermissions = {
      load: 'fleetManagement.vehicles.list',
      price: 'priceplan.list'
    };

    this.enableColumnsSection = this.mdPanelRef.config.locals.data.enableColumnsSection;

    this.settingsConfig = {
      daysBefore: this.mdPanelRef.config.locals.data.daysBefore || 0,
      daysAfter: this.mdPanelRef.config.locals.data.daysAfter || 0,
      actionType: this.mdPanelRef.config.locals.data.actionType,
      totalsTimeInterval: this.mdPanelRef.config.locals.data.totalsTimeInterval,
      defaultGroup: this.mdPanelRef.config.locals.data.defaultGroup,
      sortTimeWindow: this.mdPanelRef.config.locals.data.sortTimeWindow,
      columns: this.mdPanelRef.config.locals.data.columns,
      mapColumns: this.mdPanelRef.config.locals.data.mapColumns,
      dynamicColumns: this.mdPanelRef.config.locals.data.dynamicColumns,
      packageDynamicColumns: this.mdPanelRef.config.locals.data.packageDynamicColumns
    };

    this.columnsVisibilityMap = {};
    this.mapColumnsVisibilityMap = {};

    _.forOwn(this.settingsConfig.columns, (value, key) => {
      this.columnsVisibilityMap[key] = true;
    })

    _.forOwn(this.settingsConfig.mapColumns, (value, key) => {
      this.mapColumnsVisibilityMap[key] = true;
    })

    if (!this.splitService.getExposeAgentBranchesOnTheService()) {
      this.columnsVisibilityMap.agentOperationalUnits = false;
      this.mapColumnsVisibilityMap.agentOperationalUnits = false;
    }

  }

  onTotalsTimeIntervalButtonClicked() {
    if (!this.settingsConfig.totalsTimeInterval) {
      this.enabledSections.totalsTimeInterval = true;
      this.settingsConfig.totalsTimeInterval = 60000; //default 1 minute
    } else {
      this.enabledSections.totalsTimeInterval = false;
      this.settingsConfig.totalsTimeInterval = undefined;
    }
  }

  onToggleIsOpenDynamicColumns(isOpen) {
    this.enabledSections.dynamicColumns = !this.enabledSections.dynamicColumns;
    this.$timeout(() => {
    }, 0);
  }

  onToggleIsOpenPackageDynamicColumns(isOpen) {
    this.enabledSections.packageDynamicColumns = !this.enabledSections.packageDynamicColumns;
  }


  onChangeColumns(columnKey, isEnabled) {
    this.settingsConfig.columns[columnKey] = isEnabled;
  }

  onChangeMapColumns(columnKey, isEnabled) {
    this.settingsConfig.mapColumns[columnKey] = isEnabled;
  }

  onSelectedActionTypeChange(type) {
    this.settingsConfig.actionType = type;
  }

  onSelectedDefaultGroupChange(group) {
    this.settingsConfig.defaultGroup = group;
  }

  onToggleIsOpenColumns(isOpen) {
    this.enabledSections.columns = !this.enabledSections.columns;
  }

  onToggleIsMapOpenColumns(isOpen) {
    this.enabledSections.mapColumns = !this.enabledSections.mapColumns;
  }

  onToggleSortTimeWindow(sortTimeWindow) {
    this.settingsConfig.sortTimeWindow = sortTimeWindow === 'asc' ? 'desc' : 'asc';
  }

  onChangeDaysBefore(daysBefore) {
    if (!daysBefore) {
      daysBefore = 0;
    }
    this.settingsConfig.daysBefore = daysBefore;
  }

  onChangeDaysAfter(daysAfter) {
    if (!daysAfter) {
      daysAfter = 0;
    }
    this.settingsConfig.daysAfter = daysAfter;
  }

  onReset() {
    this.settingsConfig = {
      actionType: 'bar',
      defaultGroup: undefined,
      sortTimeWindow: undefined,
      columns: this.commonsConstants.viewsTableColumns[ServicesViewsStateType.DELIVERIES_TABLE_STATE],
      mapColumns: this.commonsConstants.viewsTableColumns[ServicesViewsStateType.DELIVERIES_MAP_STATE],
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.settingsConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }

}

